import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ResearchUnitBuilder } from '../../models/builder/research-unit.builder';
import { environment } from '../../../../environments/environment';


@Injectable()
export class ResearchUnitApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient,
  ) {
    this.apiUrl = `${environment.companyAdmin.apiUrl}research-units`;
  }

  getResearchUnits() {
    return this.httpClient.get(`${ this.apiUrl }`)
      .pipe(map(ResearchUnitBuilder.fromList));
  }
}
